export default __webpack_public_path__ + "static/media/positions-closed.f12ac6cb.svg";